/**
 * @generated by @interxfi/j5-codegen (Plugin: NormalizedQueryPlugin) - do not edit */

import type { IxfAccountingV1ManualEntryEvent } from '@interxfi/types';
import { schema } from 'normalizr';

export const IXF_ACCOUNTING_V1_MANUAL_ENTRY_EVENT_ENTITY_NAME = 'ixf.accounting.v1.ManualEntryEvent';
export const ixfAccountingV1ManualEntryEventEntity = new schema.Entity<IxfAccountingV1ManualEntryEvent>(IXF_ACCOUNTING_V1_MANUAL_ENTRY_EVENT_ENTITY_NAME, {}, { idAttribute: (entity: IxfAccountingV1ManualEntryEvent) => `${entity.metadata?.eventId}` });

